import _includes from 'lodash/includes';
import React, { Component } from 'react';
import numeral from 'numeral';
import USER_EXAM_STATUS from '@achievable-me/tundra-wizard/userExamStatus';
import MODE from '$components/review/mode';
import STEP from '$components/review/step';
import styles from './styles.scss';

const SHOW_PROGRESS_STEPS = [
  STEP.examNavigation,
  STEP.examReview,
  STEP.examSummary,
  STEP.quizPrompt,
];

class ReviewProgress extends Component {
  getProgress = () => {
    const { mode, quizState } = this.props;
    const { quizQueue, step, summary, userExam } = quizState;

    if (mode === MODE.debug || mode === MODE.share) {
      return 0;
    }

    if (mode === MODE.review) {
      if (!summary) {
        return 0;
      }

      const { answered, total } = summary;
      return answered / total;
    }

    if (!quizQueue || userExam.status === USER_EXAM_STATUS.finished) {
      return 0;
    }

    if (!_includes(SHOW_PROGRESS_STEPS, step)) {
      return 0;
    }

    const answeredItems = quizQueue.filter((entry) => entry.item.status);
    return answeredItems.length / quizQueue.length;
  };

  render() {
    const progress = this.getProgress();
    const width = numeral(1 - progress).format('0.00%');

    return (
      <div className={styles.layout}>
        <span className={styles.bar} style={{ transform: `translateX(-${width})` }} />
      </div>
    );
  }
}

export default ReviewProgress;
